import classNames from "classnames"
import { ValidationRules, UseFormMethods } from "react-hook-form"

interface InputProps
  extends Partial<Pick<UseFormMethods, "register" | "errors">> {
  rules?: ValidationRules
  name: string
  label?: string
  type: "text" | "email" | "number" | "radio" | "checkbox"
  className?: string
  onChange?: (props: any) => void
  onWheel?: (props: any) => void
  onKeyDown?: (props: any) => void
  onClick?: (props: any) => void
  defaultValue?: string | number
  placeholder?: string
  value?: string
  checked?: boolean
}

const Input: React.FC<InputProps> = ({
  name,
  type,
  label,
  rules = {},
  register,
  defaultValue,
  errors = {},
  className,
  value,
  checked,
  onChange,
  onKeyDown,
  onWheel,
  onClick,
  ...rest
}) => {
  const componentClassName = classNames(className, `input input-${name}`)

  const cssClasses = classNames({
    "error-input": errors[name]?.message,
  })

  return (
    <>
      <input
        className={`${componentClassName} ${cssClasses}`}
        aria-invalid={errors[name] ? "true" : "false"}
        type={type}
        name={name}
        id={name}
        defaultValue={defaultValue}
        value={value}
        checked={checked}
        onChange={onChange}
        onClick={onClick}
        onWheel={onWheel}
        onKeyDown={onKeyDown}
        ref={register && register(rules)}
        {...rest}
      />
      {errors[name] && <p className={`${name}-error-input`}>{errors[name].message}</p>}
    </>
  )
}

export { Input }
